(() => {
  const controlSelector =
    '.product--thumbnail_slider media-gallery > slider-component > .slider-buttons .slider-button';

  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest(controlSelector);
      if (!control) return;

      const gallery = control.closest('media-gallery');
      if (!gallery) return;

      const thumbnails = [...gallery.querySelectorAll('button.thumbnail')].filter((thumbnail) => {
        const item = thumbnail.closest('li');
        return !item || window.getComputedStyle(item).display !== 'none';
      });

      if (thumbnails.length < 2) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      let currentIndex = thumbnails.findIndex(
        (thumbnail) => thumbnail.getAttribute('aria-current') === 'true'
      );

      if (currentIndex < 0) currentIndex = 0;

      const direction = control.classList.contains('slider-button--next') ? 1 : -1;
      const targetIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;

      thumbnails[targetIndex].click();
    },
    true
  );
})();
